import type { Guide, GuideRecordHint } from '../types';

/**
 * S-26.10-10 — wynik oferty i historia wycen (makieta: wynik wyceny, „Historia wycen”, ścieżka CS-10,
 * BR-CS-16; scenariusz e2e 37). A37S — zapytanie z wysłaną ofertą. Nagrywarka tylko otwiera okno wyniku.
 */
const SENT: GuideRecordHint = {
  description: 'zapytanie z wysłaną ofertą — z listy zapytań, stan „oferta wysłana”',
  listPath: '/inquiries',
  listFilter: { status: 'offer_sent' },
};

export const guide: Guide = {
  flagKey: 'inquiryOutcomes',
  title: 'Wynik oferty i historia wycen',
  whatItDoes:
    'Po wysłaniu oferty albo potwierdzenia CS zapisuje wynik. Przyjęta — zapytanie staje się prezleceniem w tym samym rekordzie, z danymi i ceną zatwierdzoną; przy komplecie pól powstaje wiersz w banku w stanie „Prezlecenie” i dalej idzie zwykły obieg do Administracji. Odrzucona albo brak odpowiedzi — z powodem. „Historia wycen” pokazuje każdą wycenę z wynikiem i liczniki: przyjęte, odrzucone, bez odpowiedzi i najczęstszy powód odrzucenia.',
  audience: ['CS', 'Trade'],
  presentationItems: ['S-26.10-10'],
  steps: [
    {
      route: '/inquiries/:inquiryId/show',
      record: SENT,
      target: 'inquiry-outcome',
      title: 'Wynik oferty',
      description:
        '„przyjęta” tworzy prezlecenie w tym samym rekordzie; „odrzucona” i „brak odpowiedzi” — z powodem (podpowiedzi: cena, brak auta w terminie, klient wybrał innego przewoźnika).',
      action: 'Kliknij „odrzucona”, żeby zobaczyć okno powodu.',
      mockupTestId: 'cs-wycena-wynik-odrzucona',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'a37SentInquiryId' },
        actions: [{ kind: 'click', target: 'cs-wycena-wynik-odrzucona' }],
      },
    },
    {
      route: '/inquiry-history',
      target: 'inquiry-history',
      title: 'Historia wycen',
      description:
        'Każda wycena — także zastąpione — z ceną, wynikiem i powodem; u góry liczniki i najczęstszy powód odrzucenia.',
      action: 'Otwórz „Historia wycen” w menu.',
      recorder: { account: 'cs' },
    },
  ],
};
